import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, IonTextarea, LoadingController } from '@ionic/angular/lazy';
import { OrderService } from 'src/app/services/order.service';
import { ObserverService } from 'src/app/services/observer.service';

@Component({
    selector: 'app-order-add-comment',
    templateUrl: './order-add-comment.page.html',
    styleUrls: ['./order-add-comment.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderAddCommentPage implements OnInit {

    @ViewChild('comment_input', { static: false }) comment_input: IonTextarea;

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    input_focused = false;
    @Input() order_id = null;
    order = null;
    comment = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private orderService: OrderService,
        private observerService: ObserverService
    ) { }

    ngOnInit() {

        if(this.order_id) {


            this.loadData().then(() => { }).catch(() => { });

        }

        this.observerService.subscribe('network_status_changed|order_add_comment_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to add a comment, please check your network connection and try again.");
                }
            }
        });

    }

    // NOTE: focus input after rendering.
    ngAfterViewChecked() {
        if(!this.loading && this.online && !this.input_focused && this.comment_input) {
            setTimeout(() => {
                this.comment_input.setFocus();
                this.input_focused = true;
            }, 100);
        }
    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|order_add_comment_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading order").then(() => {
                this.orderService.getOrder(this.order_id).then((order) => {
                    if(order) {
                        this.order = order;
                    }
                    this.loading_spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    add() {

        let validated = true;

        if(this.comment == null || this.comment.trim() === "") {
            validated = false;
            this.presentAlert("Missing comment", "Please enter a comment.");
        }

        if(validated) {
            this.addComment().then(() => {
                this.modalController.dismiss();
            });
        }

    }

    addComment() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner('Adding comment').then(() => {
                this.orderService.addOrderComment(this.order_id, this.comment).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => { 
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}